import { render, staticRenderFns } from "./Architectures.vue?vue&type=template&id=0965fc08&scoped=true"
import script from "./Architectures.vue?vue&type=script&lang=js"
export * from "./Architectures.vue?vue&type=script&lang=js"
import style0 from "./Architectures.vue?vue&type=style&index=0&id=0965fc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0965fc08",
  null
  
)

export default component.exports